import { useQueryClient } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import { portalLogout } from '../../api/portalServices';
import { useSession } from '../../common/authorization/context/Session';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import { AppError } from '../../errorHandler/errors';
import { getSSOLogoutUrl } from '../../utils/utils';

const useLogout = () => {
  const { tenantId } = useSession();
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    if (tenantId) {
      const workflowId = uuidv4();
      queryClient.clear();
      window.location.href = getSSOLogoutUrl(tenantId, workflowId);
    }
  };
  return handleLogout;
};

const useLocalLogout = () => {
  const { tenantId, clearSession } = useSession();
  const { emitError } = useErrorContext();
  const queryClient = useQueryClient();

  return async () =>
    portalLogout(tenantId || '')
      .then(() => {
        queryClient.clear();

        clearSession();
      })
      .catch((e) => {
        console.error('Error logging out:', e);
        emitError(new AppError(e));
      });
};

export { useLogout, useLocalLogout };
